/**
 * Адрес экрана «Моя работа» с вкладкой вида — Блок 2 · Ф7 · В11-f (долг #325).
 *
 * Экран `/my` делит строки на две вкладки («Задачи» и «Проектные работы») и
 * без параметра открывает первую. Ссылка из колокольчика о ПРОЕКТНОЙ работе
 * вела на голое `/my` — человек попадал на вкладку, где этой работы нет.
 * Решение владельца 08.10.2026: вести сразу на нужную вкладку.
 *
 * ЕДИНСТВЕННЫЙ источник имени и значений параметра — для того, кто строит
 * ссылку (`notification-target.ts`), и для экрана, который её читает. Две
 * копии строки `kind` разошлись бы молча: ссылка осталась бы «верной», а
 * экран перестал бы её понимать.
 *
 * Вкладка по умолчанию (`TASK`) в адрес НЕ пишется: `/my` без параметра и есть
 * «Задачи», и два адреса одного состояния ни к чему.
 */
import { WorkKind } from '@aris/shared';

export const MY_WORK_PATH = '/my';
export const MY_WORK_KIND_PARAM = 'kind';
export const MY_WORK_DEFAULT_KIND: WorkKind = WorkKind.TASK;

const KNOWN_KINDS: readonly string[] = Object.values(WorkKind);

/** Адрес экрана, открытого на вкладке `kind`. */
export function myWorkPath(kind: WorkKind): string {
  return kind === MY_WORK_DEFAULT_KIND
    ? MY_WORK_PATH
    : `${MY_WORK_PATH}?${MY_WORK_KIND_PARAM}=${kind}`;
}

/**
 * Вкладка из значения параметра. Параметра нет ИЛИ значение неизвестно —
 * вкладка по умолчанию: адрес набирают и руками, и чужой текст в нём не должен
 * ни ронять экран, ни открывать «никакую» вкладку.
 */
export function parseMyWorkKind(raw: string | null): WorkKind {
  return raw !== null && KNOWN_KINDS.includes(raw) ? (raw as WorkKind) : MY_WORK_DEFAULT_KIND;
}
